import { faTooth } from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useLingui } from '@lingui/react/macro';

import type { FindingValidations } from '@/@types/persistUserValidations';
import { useUniversalToFDI } from '@/utils/internationalization/useUniversalToFDI';

import { useFindingSidebarTranslations } from '../../findingSidebar/constants';
import type { FindingObject, UserAnnotation } from '../../types';

import { ConfirmRejectMonitor } from './ConfirmRejectMonitor';

interface Props {
  disabled?: boolean;
  finding: FindingObject;
  isPeriapical: boolean;
  onChange: (item: FindingObject, value: FindingValidations) => void;
  onMouseEnter: (finding: FindingObject | UserAnnotation) => void;
  onMouseLeave: (finding: FindingObject | UserAnnotation) => void;
}

export const ValidationFinding = ({
  disabled,
  finding,
  isPeriapical,
  onChange,
  onMouseEnter,
  onMouseLeave,
}: Props) => {
  const { displayToothNumber } = useUniversalToFDI();
  const { typeToHeaderMap } = useFindingSidebarTranslations();
  const { t } = useLingui();

  const isRbl = ['mesial', 'distal'].includes(finding.side);
  const hasRblMeasurement = typeof finding.distanceMM === 'number';

  return (
    <div
      className="vai-mb-2"
      onFocus={() => onMouseEnter(finding)}
      onMouseEnter={() => onMouseEnter(finding)}
      onMouseLeave={() => onMouseLeave(finding)}
    >
      <div className="vai-flex vai-items-center vai-gap-4 vai-mb-2">
        <div className="vai-flex vai-items-center vai-gap-2">
          <FontAwesomeIcon
            className="vai-text-white"
            size="lg"
            icon={faTooth}
          />
          <p className="vai-text-white vai-font-inter vai-text-sm vai-font-medium">
            {displayToothNumber(finding.toothNumber)}
          </p>
        </div>
        <p className="vai-text-white vai-font-inter vai-text-sm vai-font-medium">
          {typeToHeaderMap[finding.type as keyof typeof typeToHeaderMap]}
        </p>
      </div>
      {isRbl && (
        <p className="vai-font-inter vai-text-[12px] vai-font-semibold vai-text-foreground-dark">
          {finding.side === 'mesial' ? t`Mesial` : t`Distal`}:{' '}
          {hasRblMeasurement ? (
            <>
              {finding.distanceMM}
              {isPeriapical ? '%' : 'mm'}
            </>
          ) : (
            <Trans>Unable to calculate bone level</Trans>
          )}
        </p>
      )}

      <ConfirmRejectMonitor
        disabled={disabled}
        item={finding}
        onChange={onChange}
      />

      <hr className="vai-border-background-muted vai-mt-2" />
    </div>
  );
};
